<!-- Vue 3 wrapper for Bryntum ProjectModel -->

<template>
    <div ref="refElement">

    </div>
</template>

<script>
import { AssignmentModel, AssignmentStore, CalendarManagerStore, CalendarModel, CoreStateTrackingManager, DependencyModel, DependencyStore, EventModel, EventStore, ProjectModel, ResourceModel, ResourceStore, ResourceTimeRangeModel, ResourceTimeRangeStore, Store, TimeSpan } from '@bryntum/schedulerpro';
import { getCurrentInstance, onBeforeUnmount, onMounted, ref, watch, provide } from 'vue';
import useWrapperHelper from './WrapperHelper.js';
import useWrapperHelperVue3 from './WrapperHelperVue3.js';

export default {
    name : 'BryntumProjectModel',

    props : {

         // Configs only
        adjustDurationToDST          : { type : Boolean, default : undefined },
        assignmentModelClass         : { type : Function, default : undefined },
        assignmentsData              : { type : Array, default : undefined },
        assignmentStoreClass         : { type : Function, default : undefined },
        autoLoad                     : { type : Boolean, default : undefined },
        autoSync                     : { type : Boolean, default : undefined },
        autoSyncTimeout              : { type : Number, default : undefined },
        bubbleEvents                 : { type : Object, default : undefined },
        calendarManagerStoreClass    : { type : Function, default : undefined },
        calendarModelClass           : { type : Function, default : undefined },
        calendarsData                : { type : Array, default : undefined },
        callOnFunctions              : { type : Boolean, default : undefined },
        delayCalculation             : { type : Boolean, default : undefined },
        dependenciesData             : { type : Array, default : undefined },
        dependencyModelClass         : { type : Function, default : undefined },
        dependencyStoreClass         : { type : Function, default : undefined },
        encoder                      : { type : Object, default : undefined },
        eventModelClass              : { type : Function, default : undefined },
        eventsData                   : { type : Array, default : undefined },
        eventStoreClass              : { type : Function, default : undefined },
        listeners                    : { type : Object, default : undefined },
        maxCalendarRange             : { type : Number, default : undefined },
        phantomIdField               : { type : String, default : undefined },
        phantomParentIdField         : { type : String, default : undefined },
        resetIdsBeforeSync           : { type : Boolean, default : undefined },
        resetUndoRedoQueuesAfterLoad : { type : Boolean, default : undefined },
        resourceAllocationInfoClass  : { type : Object, default : undefined },
        resourceModelClass           : { type : Function, default : undefined },
        resourcesData                : { type : Array, default : undefined },
        resourceStoreClass           : { type : Function, default : undefined },
        resourceTimeRangesData       : { type : Array, default : undefined },
        resourceTimeRangeStoreClass  : { type : Function, default : undefined },
        silenceInitialCommit         : { type : Boolean, default : undefined },
        skipSuccessProperty          : { type : Boolean, default : undefined },
        storeIdProperty              : { type : String, default : undefined },
        supportShortSyncResponse     : { type : Boolean, default : undefined },
        taskStore                    : { type : [EventStore, Object], default : undefined },
        timeRangesData               : { type : Array, default : undefined },
        timeRangeStoreClass          : { type : Function, default : undefined },
        trackResponseType            : { type : Boolean, default : undefined },
        transport                    : { type : Object, default : undefined },
        validateResponse             : { type : Boolean, default : undefined },
        writeAllFields               : { type : Boolean, default : undefined },

         // Configs and properties
        addConstraintOnDateSet                             : { type : Boolean, default : undefined },
        assignments                                        : { type : Array, default : undefined },
        assignmentStore                                    : { type : [AssignmentStore, Object], default : undefined },
        calendar                                           : { type : [String, Object, CalendarModel], default : undefined },
        calendarManagerStore                               : { type : [CalendarManagerStore, Object], default : undefined },
        calendars                                          : { type : Array, default : undefined },
        crudStores                                         : { type : Array, default : undefined },
        daysPerMonth                                       : { type : Number, default : undefined },
        daysPerWeek                                        : { type : Number, default : undefined },
        dependencies                                       : { type : Array, default : undefined },
        dependenciesCalendar                               : { type : String, default : undefined },
        dependencyStore                                    : { type : [DependencyStore, Object], default : undefined },
        enableProgressNotifications                        : { type : Boolean, default : undefined },
        events                                             : { type : Array, default : undefined },
        eventStore                                         : { type : [EventStore, Object], default : undefined },
        forceSync                                          : { type : Boolean, default : undefined },
        hoursPerDay                                        : { type : Number, default : undefined },
        json                                               : { type : String, default : undefined },
        loadUrl                                            : { type : String, default : undefined },
        resources                                          : { type : Array, default : undefined },
        resourceStore                                      : { type : [ResourceStore, Object], default : undefined },
        resourceTimeRanges                                 : { type : Array, default : undefined },
        resourceTimeRangeStore                             : { type : [ResourceTimeRangeStore, Object], default : undefined },
        skipNonWorkingTimeInDurationWhenSchedulingManually : { type : Boolean, default : undefined },
        skipNonWorkingTimeWhenSchedulingManually           : { type : Boolean, default : undefined },
        stm                                                : { type : [CoreStateTrackingManager, Object], default : undefined },
        syncApplySequence                                  : { type : Array, default : undefined },
        syncUrl                                            : { type : String, default : undefined },
        timeRanges                                         : { type : Array, default : undefined },
        timeRangeStore                                     : { type : [Store, Object], default : undefined },
        timeZone                                           : { type : [String, Number], default : undefined },
        trackProjectModelChanges                           : { type : Boolean, default : undefined },

         // Properties only
        inlineData : { type : Object, default : undefined },

         // Events
        onBeforeDestroy       : { type : Function, default : undefined },
        onBeforeLoad          : { type : Function, default : undefined },
        onBeforeLoadApply     : { type : Function, default : undefined },
        onBeforeResponseApply : { type : Function, default : undefined },
        onBeforeSend          : { type : Function, default : undefined },
        onBeforeSync          : { type : Function, default : undefined },
        onBeforeSyncApply     : { type : Function, default : undefined },
        onCatchAll            : { type : Function, default : undefined },
        onChange              : { type : Function, default : undefined },
        onCycle               : { type : Function, default : undefined },
        onDataReady           : { type : Function, default : undefined },
        onDestroy             : { type : Function, default : undefined },
        onEmptyCalendar       : { type : Function, default : undefined },
        onHasChanges          : { type : Function, default : undefined },
        onLoad                : { type : Function, default : undefined },
        onLoadCanceled        : { type : Function, default : undefined },
        onLoadFail            : { type : Function, default : undefined },
        onNoChanges           : { type : Function, default : undefined },
        onProgress            : { type : Function, default : undefined },
        onRequestDone         : { type : Function, default : undefined },
        onRequestFail         : { type : Function, default : undefined },
        onSchedulingConflict  : { type : Function, default : undefined },
        onSync                : { type : Function, default : undefined },
        onSyncCanceled        : { type : Function, default : undefined },
        onSyncDelayed         : { type : Function, default : undefined },
        onSyncFail            : { type : Function, default : undefined },

    },

    emits : [
        'beforedestroy',
        'beforeload',
        'beforeloadapply',
        'beforeresponseapply',
        'beforesend',
        'beforesync',
        'beforesyncapply',
        'catchall',
        'change',
        'cycle',
        'dataready',
        'destroy',
        'emptycalendar',
        'haschanges',
        'load',
        'loadcanceled',
        'loadfail',
        'nochanges',
        'progress',
        'requestdone',
        'requestfail',
        'schedulingconflict',
        'sync',
        'synccanceled',
        'syncdelayed',
        'syncfail'
    ],

    data : () => {
        return {
            instanceClass : ProjectModel,
            instanceName : 'ProjectModel',

            configNames : [
                'adjustDurationToDST',
                'assignmentModelClass',
                'assignmentsData',
                'assignmentStoreClass',
                'autoLoad',
                'autoSync',
                'autoSyncTimeout',
                'bubbleEvents',
                'calendarManagerStoreClass',
                'calendarModelClass',
                'calendarsData',
                'callOnFunctions',
                'delayCalculation',
                'dependenciesData',
                'dependencyModelClass',
                'dependencyStoreClass',
                'encoder',
                'eventModelClass',
                'eventsData',
                'eventStoreClass',
                'listeners',
                'maxCalendarRange',
                'phantomIdField',
                'phantomParentIdField',
                'resetIdsBeforeSync',
                'resetUndoRedoQueuesAfterLoad',
                'resourceAllocationInfoClass',
                'resourceModelClass',
                'resourcesData',
                'resourceStoreClass',
                'resourceTimeRangesData',
                'resourceTimeRangeStoreClass',
                'silenceInitialCommit',
                'skipSuccessProperty',
                'storeIdProperty',
                'supportShortSyncResponse',
                'taskStore',
                'timeRangesData',
                'timeRangeStoreClass',
                'trackResponseType',
                'transport',
                'validateResponse',
                'writeAllFields'
            ],

            propertyConfigNames : [
                'addConstraintOnDateSet',
                'assignments',
                'assignmentStore',
                'calendar',
                'calendarManagerStore',
                'calendars',
                'crudStores',
                'daysPerMonth',
                'daysPerWeek',
                'dependencies',
                'dependenciesCalendar',
                'dependencyStore',
                'enableProgressNotifications',
                'events',
                'eventStore',
                'forceSync',
                'hoursPerDay',
                'json',
                'loadUrl',
                'onBeforeDestroy',
                'onBeforeLoad',
                'onBeforeLoadApply',
                'onBeforeResponseApply',
                'onBeforeSend',
                'onBeforeSync',
                'onBeforeSyncApply',
                'onCatchAll',
                'onChange',
                'onCycle',
                'onDataReady',
                'onDestroy',
                'onEmptyCalendar',
                'onHasChanges',
                'onLoad',
                'onLoadCanceled',
                'onLoadFail',
                'onNoChanges',
                'onProgress',
                'onRequestDone',
                'onRequestFail',
                'onSchedulingConflict',
                'onSync',
                'onSyncCanceled',
                'onSyncDelayed',
                'onSyncFail',
                'resources',
                'resourceStore',
                'resourceTimeRanges',
                'resourceTimeRangeStore',
                'skipNonWorkingTimeInDurationWhenSchedulingManually',
                'skipNonWorkingTimeWhenSchedulingManually',
                'stm',
                'syncApplySequence',
                'syncUrl',
                'timeRanges',
                'timeRangeStore',
                'timeZone',
                'trackProjectModelChanges'
            ],

            propertyNames : [
                'inlineData'
            ],

            eventNames : [
                'beforeDestroy',
                'beforeLoad',
                'beforeLoadApply',
                'beforeResponseApply',
                'beforeSend',
                'beforeSync',
                'beforeSyncApply',
                'catchAll',
                'change',
                'cycle',
                'dataReady',
                'destroy',
                'emptyCalendar',
                'hasChanges',
                'load',
                'loadCanceled',
                'loadFail',
                'noChanges',
                'progress',
                'requestDone',
                'requestFail',
                'schedulingConflict',
                'sync',
                'syncCanceled',
                'syncDelayed',
                'syncFail'
            ]
        };
    },

    setup(props, { emit }) {
        const instance = {};
        const refElement = ref(null);

        // Storage for teleports (in-cell Vue component instances)
        // automatically renderer by template
        const teleports = ref(new Map());

        const { createWidget, relayStores, watchProps } = useWrapperHelper();
        const { processCellContent, hasFrameworkRenderer } = useWrapperHelperVue3();

        // Provide teleports for processCellContent
        provide('teleports', teleports);

        onMounted(() => {
            const
                me = getCurrentInstance(),
                uncapitalize = str => str.charAt(0).toLowerCase() + str.slice(1),
                eventName = str => uncapitalize(str.slice(2)),
                // Collect event listeners from me.props where they are `on` functions
                listeners = Object.keys(me.props)
                    .filter(prop => typeof me.props[prop] === 'function' && prop.startsWith('on') && prop.length > 2)
                    .map(eventName);

            instance.value = createWidget({
                me,
                props   : me.props,
                data    : me.data,
                listeners,
                emit,
                element : refElement.value
            });

            const watcher = (prop, newValue) => watch(() => me.props[prop], newValue);
            watchProps(me, instance.value, me.props, me.data, watcher);
        });

        onBeforeUnmount(() => {
            if (instance.value) {
                instance.value.destroy();
            }
        });

        return { instance, refElement, teleports };
    }
};
</script>
